// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.itoken",
    name: "iToken Wallet",
    homepage: "https://www.itoken.com/",
    image_id: "5cd60c34-038d-470c-c024-d58f64260200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id1433883012",
        android: "https://play.google.com/store/apps/details?id=com.huobionchainwallet.gp",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "huobiwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map